import React from "react";
import InputComponent from "../../UI/InputComponent/InputComponent";
import Row from "../WrapperComponents/Row";
import Col from "../WrapperComponents/Col";
import ColDynamic from "../WrapperComponents/ColDynamic";
import DatePicker from "../../UI/DatePicker/DatePicker";
import Select from "react-virtualized-select";
import "./AddressData.css";
import DatepickerComponent from "../../UI/DatePicker/DatepickerComponent";

const AddressData = (props) => {
  const { address, userData, reviserSustainabilityApproval } = props.parentState.newFormData;
  const {
    countryList,
    countyList,
    cityAndMuncipalityList,
    districtList,
    update,
  } = props.parentState;
  const { parentState, requiredRegistration, isRegistryOfCertifiedAuditors } = props;
  const { sifDrzave, sifZupanije, sifGrdOpc, sifNaselja } = address;
  const mappedCityAndMuncipalityList = cityAndMuncipalityList.map(
    (element) => element.gradoviOpcine[0]
  );

  const mappedDistrictList = districtList.map((element) => element.naselja[0]);

  const selectStyle = { borderColor: "red" };

  return (
    <>
      <div className="form-group dp-style">
        <Row>
          <ColDynamic className="col-lg-4 mb-16">
            <>
              <label htmlFor="country">
                Država{props.required && "*"}{" "}
              </label>

              <Select
                id="country"
                disabled={props.disableCountry}
                noResultsText={"Nema rezultata"}
                placeholder="Odaberi državu"
                options={countryList}
                onChange={(selectValue) =>
                  props.autocompleteCountryHandler(selectValue, {
                    formGroup: "address",
                    value: "sifDrzave",
                    code: "sifDrzave",
                    name: "nazivDrzave",
                  })
                }
                labelKey="nazivKratki"
                valueKey="sifDrzave"
                value={address.sifDrzave}
              />
            </>
          </ColDynamic>

          <Col>
            {sifDrzave != "191" && sifDrzave !== "" ? (
              <InputComponent
                name="nazZupanije"
                onChange={props.userInputHandler}
                objData={{ group: "address" }}
                value={address.nazZupanije}
                id="nazZupanije"
                controlLabel={"Naziv županije"}
              />
            ) : (
              <>
                <label htmlFor="naz_zupanije">
                  Naziv županije{props.required && "*"}{" "}
                </label>
                <Select
                  noResultsText={"Nema rezultata"}
                  style={
                    (props.required &&
                      props.parentState.error &&
                      address.sifZupanije.length < 1 &&
                      selectStyle) ||
                    null
                  }
                  placeholder="Odaberi županiju"
                  disabled={props.disableCounty}
                  options={countyList}
                  onChange={(selectValue) =>
                    props.autocompleteCountyHandler(selectValue, {
                      formGroup: "address",
                      value: "sifZupanije",
                      code: "sifZupanije",
                      name: "nazZupanije",
                    })
                  }
                  id="naz_zupanije"
                  labelKey="nazZupanije"
                  valueKey="sifZupanije"
                  value={address.sifZupanije}
                />
              </>
            )}
          </Col>
        </Row>

        <Row>
          {sifDrzave != 191 && sifDrzave !== "" ? (
            <>
              <Col>
                <InputComponent
    
                  name="nazGrdOpc"
                  onChange={props.userInputHandler}
                  objData={{ group: "address" }}
                  value={address.nazGrdOpc}
                  id="nazGrdOpc"
                  controlLabel={"Naziv grada/općine"}
                />
              </Col>
              <Col>
                <InputComponent
                  required={props.required}
                  style={
                    props.required &&
                    props.parentState.error &&
                    address.nazNaselja.length < 1 &&
                    "red"
                  }
                  name="nazNaselja"
                  onChange={props.userInputHandler}
                  objData={{ group: "address" }}
                  value={address.nazNaselja}
                  id="nazNaselja"
                  controlLabel={"Naziv mjesta"}
                />
              </Col>
            </>
          ) : (
            <>
              <ColDynamic className="col-lg-4 mb-16">
                <>
                  <label htmlFor="naz_grada">
                    Naziv grada ili općine{props.required && "*"}{" "}
                  </label>
                  <Select
                    id="naz_grada"
                    noResultsText={"Nema rezultata"}
                    style={
                      (props.required &&
                        props.parentState.error &&
                        address.sifGrdOpc.length < 1 &&
                        selectStyle) ||
                      null
                    }
                    placeholder="Odaberi grad ili općinu"
                    disabled={props.disableCity}
                    options={mappedCityAndMuncipalityList}
                    onChange={(selectValue) =>
                      props.autocompleteCityHandler(selectValue, {
                        formGroup: "address",
                        value: "sifGrdOpc",
                        code: "sifGrdOpc",
                        name: "nazGrdOpc",
                      })
                    }
                    labelKey="nazGrdOpc"
                    valueKey="sifGrdOpc"
                    value={address.sifGrdOpc}
                  />
                </>
              </ColDynamic>
              <Col>
                <>
                  <label htmlFor="naz_mjesta">
                    Naziv mjesta{props.required && "*"}{" "}
                  </label>
                  <Select
                    id="naz_mjesta"
                    noResultsText={"Nema rezultata"}
                    style={
                      (props.required &&
                        props.parentState.error &&
                        address.sifNaselja.length < 1 &&
                        selectStyle) ||
                      null
                    }
                    placeholder="Odaberi mjesto"
                    disabled={props.disableDistrict}
                    options={mappedDistrictList}
                    onChange={(selectValue) =>
                      props.autocompleteDistrictHandler(selectValue, {
                        formGroup: "address",
                        value: "sifNaselja",
                        code: "sifNaselja",
                        name: "nazNaselja",
                      })
                    }
                    labelKey="nazNaselja"
                    valueKey="sifNaselja"
                    value={address.sifNaselja}
                  />
                </>
              </Col>
            </>
          )}
        </Row>
        <Row>
          <Col>
            <InputComponent
              required={props.requiredBrPoste}
              style={
                props.requiredBrPoste &&
                props.parentState.error &&
                address.brPoste.length < 1 &&
                "red"
              }
              name="brPoste"
              onChange={props.userInputHandler}
              objData={{ group: "address" }}
              value={address.brPoste}
              id={`address-br-poste`}
              controlLabel={"Poštanski broj"}
            />
          </Col>
          <Col>
            <InputComponent
              required={props.requiredKbr}
              style={
                props.requiredKbr &&
                props.parentState.error &&
                address.ulicaKbr.length < 1 &&
                "red"
              }
              onChange={props.userInputHandler}
              objData={{ group: "address" }}
              value={address.ulicaKbr}
              name="ulicaKbr"
              id={`address-ulica-kbr`}
              controlLabel={"Ulica i kućni broj"}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <InputComponent
              required={requiredRegistration}
              style={
                props.requiredRegistration &&
                props.parentState.error &&
                address.permitNumber.length < 1 &&
                "red"
              }
              onChange={props.userInputHandler}
              objData={{ group: "address" }}
              value={address.permitNumber}
              id="permitNumber"
              // type={"number"}
              type="text"
              min="0"
              name="permitNumber"
              controlLabel={props.permitNumberLabel}
            />
          </Col>
          {update ? (
            <Col>
              <InputComponent
                disabled
                required={requiredRegistration}
                style={
                  props.requiredRegistration &&
                  props.parentState.error &&
                  userData.regBroj.length < 1 &&
                  "red"
                }
                onChange={props.userInputHandler}
                objData={{ group: "userData" }}
                value={userData.regBroj}
                id="regBroj"
                type={"number"}
                name="regBroj"
                min="0"
                controlLabel={"Registarski broj"}
              ></InputComponent>
            </Col>
          ) : (
            <Col>
              <DatepickerComponent
                required={requiredRegistration}
                errorBorderColor={
                  parentState.error && address.permitDate.length < 1 && "red"
                }
                handleDayClick={props.handleDayClick}
                value={address.permitDate}
                controlLabel={props.permitDateLabel}
                width={"100%"}
                index={{ group: "address", prop: "permitDate" }}
              />
            </Col>
          )}
        </Row>
        {!isRegistryOfCertifiedAuditors && (
          <Row>
            {update && (
              <>
                <Col>
                  <DatepickerComponent
                    required={requiredRegistration}
                    errorBorderColor={
                      parentState.error && address.permitDate.length < 1 && "red"
                    }
                    handleDayClick={props.handleDayClick}
                    value={address.permitDate}
                    controlLabel={props.permitDateLabel}
                    width={"100%"}
                    index={{ group: "address", prop: "permitDate" }}
                  />
                </Col>
                <Col>{props.children}</Col>
              </>
            )}
          </Row>
        )}
        {isRegistryOfCertifiedAuditors && (
          <>
            <Row>
              {update && (
                <>
                  <Col>
                    <DatepickerComponent
                      required={requiredRegistration}
                      errorBorderColor={
                        parentState.error && address.permitDate.length < 1 && "red"
                      }
                      handleDayClick={props.handleDayClick}
                      value={address.permitDate}
                      controlLabel={props.permitDateLabel}
                      width={"100%"}
                      index={{ group: "address", prop: "permitDate" }}
                    />
                  </Col>
                  <Col>
                    <InputComponent
                      //required={requiredSustainabilityApproval}
                      onChange={props.userInputHandler}
                      objData={{ group: "reviserSustainabilityApproval" }}
                      value={reviserSustainabilityApproval?.brojOdrzivosti || ""}
                      id="brojOdrzivosti"
                      // type={"number"}
                      type="text"
                      min="0"
                      name="brojOdrzivosti"
                      controlLabel={"Broj odobrenja za rad za obavljanje provjere izvještaja o održivosti"}
                    />
                  </Col>
                </>
              )}
            </Row>
            <Row>
              {!update && (
                <Col>
                <InputComponent
                  //required={requiredSustainabilityApproval}
                  onChange={props.userInputHandler}
                  objData={{ group: "reviserSustainabilityApproval" }}
                  value={reviserSustainabilityApproval?.brojOdrzivosti || ""}
                  id="brojOdrzivosti"
                  // type={"number"}
                  type="text"
                  min="0"
                  name="brojOdrzivosti"
                  controlLabel={"Broj odobrenja za rad za obavljanje provjere izvještaja o održivosti"}
                />
              </Col>
              )}
              <Col>
                <DatepickerComponent
                  //required={requiredSustainabilityApproval}
                  handleDayClick={props.handleDayClick}
                  value={reviserSustainabilityApproval?.datumOdrzivosti || ""}
                  controlLabel={"Datum odobrenja za rad za obavljanje provjere izvještaja o održivosti"}
                  width={"100%"}
                  index={{ group: "reviserSustainabilityApproval", prop: "datumOdrzivosti" }}
                />
              </Col>
              {update && (
              <Col>{props.children}</Col>
              )}
            </Row>
            {!update && (
              <Row>
                <Col>{props.children}</Col>
              </Row>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default AddressData;
